import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomMarks from './CustomMarks';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomMarks, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/slider/demos/custom-marks/CustomMarks.tsx",
    "fileName": "CustomMarks.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\nimport Typography from '@mui/material/Typography';\n\nconst MAX = 100;\nconst MIN = 0;\nconst marks = [\n  {\n    value: MIN,\n    label: '',\n  },\n  {\n    value: MAX,\n    label: '',\n  },\n];\n\nexport default function CustomMarks() {\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus-unfocused",
            "dataFrameIndent": 0,
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  const [val, setVal] = React.useState<number>(MIN);\n  const handleChange = (_: Event, newValue: number) => {\n    setVal(newValue);\n  };\n\n  return (\n    <Box sx={{ width: 250 }}>\n      <Slider\n        marks={marks}\n        step={10}\n        value={val}\n        valueLabelDisplay=\"auto\"\n        min={MIN}\n        max={MAX}\n        onChange={handleChange}\n      />\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Typography\n          variant=\"body2\"\n          onClick={() => setVal(MIN)}\n          sx={{ cursor: 'pointer' }}\n        >\n          {MIN} min\n        </Typography>\n        <Typography\n          variant=\"body2\"\n          onClick={() => setVal(MAX)}\n          sx={{ cursor: 'pointer' }}\n        >\n          {MAX} max\n        </Typography>\n      </Box>\n    </Box>\n  );\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 54,
        "focusedLines": 0,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport Box from '@mui/material/Box';\nimport Slider from '@mui/material/Slider';\nimport Typography from '@mui/material/Typography';\n\nconst MAX = 100;\nconst MIN = 0;\nconst marks = [\n  {\n    value: MIN,\n    label: '',\n  },\n  {\n    value: MAX,\n    label: '',\n  },\n];\n\nexport default function CustomMarks() {\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus-unfocused",
          "dataFrameIndent": 0
        },
        "  const [val, setVal] = React.useState<number>(MIN);\n  const handleChange = (_: Event, newValue: number) => {\n    setVal(newValue);\n  };\n\n  return (\n    <Box sx={{ width: 250 }}>\n      <Slider\n        marks={marks}\n        step={10}\n        value={val}\n        valueLabelDisplay=\"auto\"\n        min={MIN}\n        max={MAX}\n        onChange={handleChange}\n      />\n      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>\n        <Typography\n          variant=\"body2\"\n          onClick={() => setVal(MIN)}\n          sx={{ cursor: 'pointer' }}\n        >\n          {MIN} min\n        </Typography>\n        <Typography\n          variant=\"body2\"\n          onClick={() => setVal(MAX)}\n          sx={{ cursor: 'pointer' }}\n        >\n          {MAX} max\n        </Typography>\n      </Box>\n    </Box>\n  );\n"
      ],
      [
        "span",
        "frame",
        "}\n"
      ]
    ],
    "totalLines": 54,
    "focusedLines": 0,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/Box",
      "@mui/material/Slider",
      "@mui/material/Typography"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
